import axiosInstance from "../configs/axios/axiosInstance";

const TemplateServices = {

    getTemplatesList: async (filters: any) => {
        const response = await axiosInstance.get('Template/xxx', { params: filters });
        return response.data;
    },

    getFiledsMappings: async (data: any) => {
        const response = await axiosInstance.get('Template/xxx', { params: data });
        return response.data;
    },

    deleteTemplate: async (templateID: string) => {
        const params = { templateID };
        const response = await axiosInstance.delete('Template/DeleteTemplate', { params: params });
        return response.data;
    },

    getStandardOrderTemplateFields: async () => {
        const response = await axiosInstance.get('Template/GetStandardTemplateDbFields');
        return response.data;
    },

    getTemplates: async (countryID: string) => {
        const params = { countryID };
        const response = await axiosInstance.get('Template/GetTemplates', { params: params });
        return response.data;
    },

    createTemplate: async (payload: any) => {
        const response = await axiosInstance.post('Template/AddTemplate', payload);
        return response.data;
    },

    getTemplateDetails: async (templateID: string) => {
        const params = { templateID };
        const response = await axiosInstance.get('Template/GetTemplateDetails', { params: params });
        return response.data;
    },

};

export default TemplateServices;
